module.exports = "https://cdn.realtymogul.com/static/media/guidance_bg.ae0fe7ca.jpg";